import { MERGED_TAG_TOKEN } from '@/model/middleware-types'

const PATIENT_LOOKUP_FIELDS = ['name', 'phone'] as const

function stripQueryPrefix(query: string): string {
  return query.replace(/^[?&]/, '')
}

function escapeFhirFilterString(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
}

export function buildPatientLookupFilter(searchText: string): string {
  const query = searchText.trim()

  if (!query) {
    return ''
  }

  const escapedQuery = escapeFhirFilterString(query)
  return PATIENT_LOOKUP_FIELDS.map((field) => `${field} co "${escapedQuery}"`).join(' or ')
}

export function buildPatientLookupSearchQuery(searchText: string, baseQuery = ''): string {
  const params = new URLSearchParams(stripQueryPrefix(baseQuery))
  // A merged-away record must not be picked; its chart redirects to the kept one (PD-1986).
  params.set('_tag:not', MERGED_TAG_TOKEN)
  const lookupFilter = buildPatientLookupFilter(searchText)

  if (!lookupFilter) {
    return params.toString()
  }

  const existingFilter = params.get('_filter')
  params.set('_filter', existingFilter ? `(${existingFilter}) and (${lookupFilter})` : lookupFilter)

  return params.toString()
}
